

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const partnerNotificationApi = createAsyncThunk(
  "partnerNotification",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/partnerGetData", { params });
    return response.data;
  }
);

const sipSlice = createSlice({
  name: "partnerNotification",
  initialState: {
    partnerNotification: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(partnerNotificationApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(partnerNotificationApi.fulfilled, (state, action) => {
        state.partnerNotification = action.payload;
        state.loading = false;
      })
      .addCase(partnerNotificationApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default sipSlice.reducer;
